import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import CaseInfo from "@/features/case-evaluation/case-information";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_backoffice/case-classification_/create")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<Content pageName="New Case">
			{/*<Header title="New Case" />*/}

			<div className="flex flex-col w-full max-w-base p-6">
				<div className="mb-20">
					<CaseInfo attachment={false} caseNumber={false} payments={true} upload={true} data={undefined} />
				</div>
			</div>
		</Content>
	);
}
